// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".KoJcH a div{opacity:0;-webkit-transition:.3s ease;-o-transition:.3s ease;transition:.3s ease}.KoJcH:hover a div{opacity:1}._15FNi{margin:20px;text-align:center}", ""]);
// Exports
exports.locals = {
	"tile": "KoJcH",
	"actionBtns": "_15FNi"
};
module.exports = exports;
